var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "save",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5H3.2C1.4 0.5 0 1.9 0 3.7V17.4C0 19.1 1.4 20.5 3.2 20.5H16.9C18.6 20.5 20.1 19.1 20.1 17.3V6.5C20.1 5.5 19.7 4.5 19 3.8L16.8 1.6C16 0.9 15 0.5 14 0.5ZM13.3 18.3H6.7V15.1C6.7 14.4 7.2 13.9 7.9 13.9H12.2C12.9 13.9 13.4 14.4 13.4 15.1V18.3H13.3ZM16.2 18.3H15.5V13.2C15.5 12.3 14.8 11.6 13.9 11.6H6.1C5.2 11.6 4.5 12.3 4.5 13.2V18.3H3.8C3 18.3 2.3 17.6 2.3 16.8V4.3C2.3 3.5 3 2.8 3.8 2.8H13.5C14.3 2.8 15 3.1 15.5 3.6L17 5.1C17.5 5.6 17.8 6.4 17.8 7.1V16.8C17.8 17.6 17.1 18.3 16.2 18.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.e8802c474a61f8ef5aca44a7501757af.svg";
export { ForwardRef as ReactComponent };